import { render, staticRenderFns } from "./ServiceCountIcon.vue?vue&type=template&id=2bca373a"
import script from "./ServiceCountIcon.vue?vue&type=script&lang=js"
export * from "./ServiceCountIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports